/**
 * 重みを加味した上でのランダム選択(乱択)関数 O(N)
 * @param valueWeightMap [値, 重み]タプルの配列
 * @param randValue [0,1)の乱数 デフォルトはMath.random() (テスト用)
 * @returns いずれかの値
 */
export const randomSelect = <T>(
  valueWeightMap: readonly (readonly [T, number])[],
  randValue = Math.random()
): T | undefined => {
  const filtered = valueWeightMap.filter(([, weight]) => weight > 0)
  if (filtered[0] === undefined) throw new Error('Invalid map')
  const weightList = filtered.reduce<number[]>(
    (acc, [, cur]) => [...acc, (acc[acc.length - 1] ?? 0) + cur],
    []
  )
  const sum = weightList[weightList.length - 1] ?? 1
  const rand = randValue * sum

  for (let i = 0; i < weightList.length; i += 1) {
    if ((weightList[i] ?? 0) > rand) return filtered[i]?.[0]
  }
  return filtered[0][0]
}
